/** Leaderboard period toggle. UI-only for now — Week and Overall both render the same data. */
export type LeaderboardPeriod = 'week' | 'overall';

export const PODIUM_PERIOD_OPTIONS: ReadonlyArray<{ key: LeaderboardPeriod; label: string }> = [
  { key: 'overall', label: 'Overall' },
  { key: 'week', label: 'Week' },
];

export const PODIUM_BLOCK_HEIGHTS = {
  first: 76,
  second: 52,
  third: 38,
} as const;

export const PODIUM_GLOW = {
  first: '#FFCB47',
  second: '#A78BFA',
  third: '#FF8A65',
} as const;

export const PODIUM_BLOCK_COLORS = {
  first: {
    faceTop: '#FFD23F',
    faceBottom: '#E8A82A',
    side: '#9A6F12',
    edge: '#FFE680',
    numeralColor: 'rgba(40,28,0,0.55)',
  },
  rest: {
    faceTop: '#2E2740',
    faceBottom: '#1C1830',
    side: '#0E0B1A',
    edge: '#3B3252',
    numeralColor: 'rgba(255,255,255,0.18)',
  },
} as const;

export const PODIUM_COPY = {
  PERIOD_A11Y: 'Leaderboard period',
} as const;

export const PODIUM_TOGGLE_COLORS = {
  rowBg: 'rgba(0,0,0,0.4)',
  /** Dark brown ink on the gold active pill — picked for AA contrast on `theme.accent`. */
  labelActive: '#3a2a00',
} as const;
